import { hasPrivilege } from 'cadenza/access-management/model/object-privilege-util';
import { objecttypeIdFromString } from 'cadenza/repository/model/objecttype-id.gen';
import { repositoryService } from 'cadenza/repository/repository-service';
import { getStore } from 'cadenza/store/cadenza-store';
import type { Objecttype } from 'cadenza/workbook/api/objecttype';
import {
  getWorkbookRepositoryName,
  isWorkbookPublished,
  isWorkbookWritable,
} from 'cadenza/workbook/workbook-core-selectors.state';
import { isWorkbookFeatureAvailable } from 'cadenza/workbook/workbook-features';

type HierarchyCreationAllowedCheckResult = 'allowed' | 'disallowed' | 'allowedWithNewVersion';

/**
 * Checks whether combination of rights on the workbook and the publishingProcess value of the objecttype repository allows to create a date hierarchy from an attribute
 */
export async function userCanCreateHierarchyOnWorkbookAndObjecttypeRepository(
  objecttype: Objecttype,
): Promise<HierarchyCreationAllowedCheckResult> {
  if (
    !isWorkbookFeatureAvailable(getStore().getState(), 'workbook-view-management') ||
    !hasPrivilege(objecttype, 'write') ||
    objecttype.boundState !== 'BOUND_TO_WORKBOOK'
  ) {
    return 'disallowed';
  }
  const { repositoryName } = objecttypeIdFromString(objecttype.id);
  const otRepository = await repositoryService().get(repositoryName);
  if (!otRepository || !hasPrivilege(otRepository, 'modifyContent')) {
    return 'disallowed';
  }
  if (isWorkbookPublished(getStore().getState())) {
    const workbookRepositoryName = getWorkbookRepositoryName(getStore().getState());
    if (workbookRepositoryName === repositoryName) {
      return isWorkbookWritable(getStore().getState()) ? 'allowedWithNewVersion' : 'disallowed';
    } else if (otRepository.publishingProcessEnabled) {
      return 'disallowed';
    }
  }
  return 'allowed';
}
